import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import { getPlanDiscountPercent, getPricePerDayLabel } from '../../shared/plan-helpers';
import styles from './SubscriptionCardV8.css';

const cx = classnames.bind(styles);

function SubscriptionCardV8({ subscriptionData, selectedSubscriptionData, selectSubscription, spriteVersion, name = 'subscription-plan' }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const discountPercent = getPlanDiscountPercent(subscriptionData);
    const isDiscountShown = discountPercent > 0;
    const isSaleBadgeShown = isDiscountShown && !subscriptionData.isDiscountBadgeHidden;
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const newPrice = subscriptionData.trial?.price ?? subscriptionData.price;

    return (
        <label className={cx('root', { active: isActive })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>Most popular</div>
            )}
            <div className={styles.content}>
                <div className={styles.detailsRow}>
                    <div className={styles.planGroup}>
                        <span className={styles.radio}>
                            <span className={styles.radioDot} />
                        </span>
                        <div className={styles.planInfo}>
                            <div className={styles.nameRow}>
                                <p className={styles.name}>{subscriptionData.name}</p>
                                {isSaleBadgeShown && (
                                    <div className={styles.saleBadge}>
                                        <EmojiIcon name='fire' version={spriteVersion} className={styles.fireEmoji} />
                                        <span>{`SAVE ${discountPercent}%`}</span>
                                    </div>
                                )}
                            </div>
                            <p className={styles.priceRow}>
                                {isDiscountShown && <span className={styles.oldPrice}>{oldPrice}</span>}
                                <span className={styles.newPrice}>{newPrice}</span>
                            </p>
                        </div>
                    </div>
                    <div className={styles.perDayBox}>
                        <p className={styles.perDayPrice}>{getPricePerDayLabel(subscriptionData)}</p>
                        <p className={styles.perDayCaption}>per day</p>
                    </div>
                </div>
                {isActive && (
                    <>
                        <div className={styles.divider} />
                        <ul className={styles.features}>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Personalized follow-up</strong>{' questions'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Voice or text</strong>{' answers'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Automatic</strong>{' chapter editing'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p>{'Your completed '}<strong>Digital Memoir</strong>{' with photos'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p>{'Cancel '}<strong>anytime</strong></p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Keep access</strong>{' to everything you create'}</p>
                            </li>
                        </ul>
                    </>
                )}
            </div>
        </label>
    );
}

SubscriptionCardV8.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    spriteVersion: PropTypes.string.isRequired,
    name: PropTypes.string
};

export {
    SubscriptionCardV8
};
